import { render, staticRenderFns } from "./VedioStat.vue?vue&type=template&id=07b56414&scoped=true"
import script from "./VedioStat.vue?vue&type=script&lang=js"
export * from "./VedioStat.vue?vue&type=script&lang=js"
import style0 from "./VedioStat.vue?vue&type=style&index=0&id=07b56414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b56414",
  null
  
)

export default component.exports